import {
  FormField,
  FormGrid,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { SubmitHandler, useForm } from 'react-hook-form';

import { HookFormQueuesSelect } from 'components/hookForm';
import { createAppModal } from 'utils/modal';

type FieldValues = {
  readonly queueId: string[];
};

/** A modal for selecting a queue for conversation follow-up. */
export const ConversationFollowUpQueueSelectModal = createAppModal(
  { type: 'conversation:followUpQueueSelect' },
  ({ isOpen, meta, hide }): JSX.Element => {
    const form = useForm<FieldValues>({
      mode: 'all',
      defaultValues: {
        queueId: [],
      },
    });

    const handleValidSubmit: SubmitHandler<FieldValues> = (values) => {
      meta?.resolve({ queueId: values.queueId[0] });
      hide?.();
    };

    return (
      <Modal isOpen={isOpen} onClose={hide}>
        <ModalHead onClose={hide} title="Select queue for follow-up" />

        <ModalBody>
          <FormGrid>
            <FormField>
              The conversation will be offered as an open conversation in the
              selected queue when the follow-up expires.
            </FormField>

            <FormField>
              <HookFormQueuesSelect
                name="queueId"
                label="Queue"
                control={form.control}
                rules={{ required: 'Queue is required' }}
                componentProps={{
                  placeholder: 'Search for a queue',
                }}
              />
            </FormField>
          </FormGrid>
        </ModalBody>

        <ModalFoot
          confirmOnClick={form.handleSubmit(handleValidSubmit)}
          confirmName="Mark as follow-up"
          confirmProps={{
            disabled: !form.formState.isValid,
          }}
          cancelName="Cancel"
          cancelOnClick={hide}
        />
      </Modal>
    );
  },
);
